import qs from "qs";
import React, { useEffect, useState } from "react";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { useGetMenuItems, useGetAllSubCategories } from "../../../queryHooks";
import CS from "../../../services/commonService";
//	Pre-defined values
const columnKey = "restaurantMenuItems";
//	Component starts
const MenuItemsTable = ({ restaurantId, tabChangeCounter }) => {
	//	State values
	const [subCategories, setSubCategories] = useState([]);
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [menuItemsPayload, setMenuItemsPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
	});

	const { data: dataGetAllRestaurants, isLoading } = useGetMenuItems({
		params: qs.stringify(menuItemsPayload),
		id: restaurantId,
	});

	useEffect(() => {
		if (dataGetAllRestaurants && dataGetAllRestaurants.status === "success") {
			let respData = dataGetAllRestaurants.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetAllRestaurants]);

	const { data: dataGetSubCategories } = useGetAllSubCategories(restaurantId);

	useEffect(() => {
		if (dataGetSubCategories && dataGetSubCategories.data?.data?.records) {
			let _categories = [];
			dataGetSubCategories.data.data.records.forEach((element) => {
				_categories.push({
					label: element.name,
					value: element.id,
				});
			});
			setSubCategories(_categories);
		}
	}, [dataGetSubCategories]);

	useEffect(() => {
		setMenuItemsPayload({
			...menuItemsPayload,
			filter: undefined,
		});
	}, [tabChangeCounter]);

	useEffect(() => {
		setPageNow(1);
		setItemsPerPage(10);
		setMenuItemsPayload({
			pagination: true,
			items_per_page: 10,
			page: 1,
		});
	}, [restaurantId]);

	const columns = [
		{
			label: "Item Info",
			type: "string",
			sort: true,
			path: "name",
			alias: "data_menu_items.name",
			content: (item) => (
				<>
					<span>{CS.renderImageUrl(item.image_url)}</span>
					<span className="pl-2">{item.name}</span>{" "}
					{item.is_alcoholic === 1 ? (
						<span className="text-danger">(Alcoholic)</span>
					) : (
						""
					)}
				</>
			),
		},
		{
			label: "Category",
			type: "string",
			sort: true,
			path: "sub_category_name",
			alias: "sub_category_name",
			aliasFilter: "data_menu_sub_categories.id",
			filterOptions: subCategories,
		},
		{
			label: "Price",
			type: "string",
			sort: true,
			path: "price",
			alias: "data_menu_items.price",
			content: (item) => `$ ${item.price}`,
		},
	];

	return (
		<>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setMenuItemsPayload({
														...menuItemsPayload,
														search: {
															"data_menu_items.name":
																!value && value === "" ? undefined : value,
															"data_menu_items.description":
																!value && value === "" ? undefined : value,
															"data_menu_sub_categories.name":
																!value && value === "" ? undefined : value,
															"core_menu_categories.name":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setMenuItemsPayload({
										...menuItemsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setMenuItemsPayload({ ...menuItemsPayload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setMenuItemsPayload({
										...menuItemsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											menuItemsPayload.filter,
											obj
										);
										setPageNow(1);
										setMenuItemsPayload({
											...menuItemsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setMenuItemsPayload({
											...menuItemsPayload,
											filter: {
												...menuItemsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setMenuItemsPayload({
										...menuItemsPayload,
										filter_date: dates && {
											...menuItemsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
								tabChangeCounter={tabChangeCounter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MenuItemsTable;
